<template>
    <div :class="getCSSClass('repository-manager-upload-popup-inner')" style="position: relative"
         v-on:dragover="$event.preventDefault()"
         v-on:drop="handleFileDrop"
    >{{ translate('Húzzon ide fájlokat a feltöltéshez')}}
        <label for="fileupload" :class="getCSSClass('repository-manager-upload-popup-file-input-label')">
            <input type="file"
                   v-on:change="handleUploadInputChange"
                   multiple
                   style="opacity: 0; width: 0; height: 0; border: 0; margin: 0; padding: 0" id="fileupload">
            {{ translate('vagy kattintson a fájlok kiválasztásához')}}
        </label>
        <div style="position: absolute; bottom: 0px; left: 0px; width: 100%;" v-if="currentUpload">
            <div :style="{width: currentUploadProgressPercentage}"
                 style="position: absolute; bottom: 0px; left: 0px; transition: width 75ms linear"
                 :class="getCSSClass('repository-manager-upload-progress-bar')"
            ></div>
            <div
                    style="position: absolute; bottom: 0px; left: 0px; width:100%;"
                    v-html="currentUpload.name"
                    :class="getCSSClass('repository-manager-upload-progress-bar-text')"
            ></div>

        </div>
    </div>

</template>

<script>
    import {repositoryUploadFunctions} from "./mixins/repositoryUploadFunctions";
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        mixins: [repositoryUploadFunctions],
        props: {
            operationsUrl: {type: String},
            repositorySlug: {type: String},
            currentPath: {}
        },
        data: function () {
            return {
            }
        },
        mounted() {
        },
        methods: {

        },
        computed: {
        },
        watch: {}

    }
</script>
